var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _circle, _circle2, _circle3, _path9, _path10, _path11, _path12, _circle4, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollectiveEncouragingSomeone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 148,
    viewBox: "0 0 277 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.211 126.879C180.817 128.42 196.338 115.396 197.879 97.7902C199.419 80.1843 186.395 64.6633 168.789 63.123C151.184 61.5827 135.662 74.6064 134.122 92.2122C132.582 109.818 145.606 125.339 163.211 126.879Z",
    fill: "#EC1D4F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10814_8122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.788 79.4842C163.518 77.709 165.316 76.6143 167.229 76.7816C169.75 77.0022 171.563 79.3046 171.185 81.8076L170.166 88.5696L169.129 108.658L159.116 107.782C158.326 107.713 157.741 107.017 157.81 106.227L159.361 88.5042C159.412 87.9254 159.55 87.3576 159.771 86.8203L162.788 79.4842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.81 88.5377L178.192 89.271C181.518 89.5621 183.641 92.9558 182.447 96.0741L179.098 104.825C178.066 107.52 175.374 109.204 172.5 108.952L162.336 108.063L169.81 88.5377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.426,
    y: 86.7559,
    width: 8.61539,
    height: 20.1026,
    rx: 1.4359,
    transform: "rotate(5 149.426 86.7559)",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.953 126.932C120.38 125.853 132.011 112.473 130.932 97.0469C129.853 81.6206 116.473 69.9896 101.047 71.0683C85.6207 72.147 73.9897 85.527 75.0684 100.953C76.1471 116.38 89.5271 128.011 104.953 126.932Z",
    fill: "#EC1D4F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10814_8122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.1005 86.0315C98.4884 84.3974 99.8932 83.205 101.569 83.0879C103.778 82.9334 105.66 84.6751 105.676 86.8899L105.72 92.8734L107.574 110.376L98.8006 110.99C98.1084 111.038 97.508 110.516 97.4596 109.824L96.3738 94.2958C96.3383 93.7887 96.38 93.2791 96.4974 92.7845L98.1005 86.0315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.407 92.8955L112.752 92.3819C115.666 92.1781 117.965 94.8205 117.36 97.6788L115.663 105.7C115.141 108.17 113.045 109.994 110.526 110.17L101.621 110.793L105.407 92.8955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.5469,
    y: 94.1445,
    width: 7.53846,
    height: 17.5897,
    rx: 1.25641,
    transform: "rotate(-4 87.5469 94.1445)",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.256 84.9672C143.492 84.2735 153.66 72.9807 152.967 59.744C152.273 46.5074 140.98 36.3393 127.743 37.033C114.507 37.7267 104.339 49.0195 105.032 62.2562C105.726 75.4928 117.019 85.6609 130.256 84.9672Z",
    fill: "#EC1D4F"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10814_8122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.993 49.8107C125.35 48.4161 126.572 47.4152 128.009 47.3399C129.905 47.2405 131.492 48.7614 131.473 50.6597L131.421 55.7883L132.748 70.8164L125.22 71.2109C124.626 71.242 124.119 70.7858 124.088 70.1918L123.39 56.8675C123.367 56.4324 123.41 55.9963 123.518 55.5741L124.993 49.8107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.152 55.8019L137.454 55.4716C139.955 55.3406 141.886 57.6395 141.325 60.0801L139.751 66.9293C139.266 69.038 137.442 70.5699 135.281 70.6831L127.64 71.0836L131.152 55.8019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.828,
    y: 56.6055,
    width: 6.46154,
    height: 15.0769,
    rx: 1.07692,
    transform: "rotate(-3 115.828 56.6055)",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3456 80.824C98.9219 78.9767 111.673 63.2307 109.825 45.6544C107.978 28.0781 92.2321 15.3273 74.6558 17.1746C57.0795 19.022 44.3286 34.7679 46.176 52.3442C48.0233 69.9205 63.7693 82.6714 81.3456 80.824Z",
    fill: "#EC1D4F"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_10814_8122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.8871 34.3797C72.2649 32.4979 73.8219 31.08 75.7308 30.8793C78.2482 30.6147 80.4669 32.529 80.5739 35.0581L80.8631 41.8904L83.6784 61.8077L73.6822 62.8584C72.8935 62.9413 72.187 62.3691 72.1041 61.5805L70.2445 43.8878C70.1838 43.31 70.2111 42.7263 70.3254 42.1567L71.8871 34.3797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5061 41.9289L88.8743 41.0494C92.1949 40.7004 94.9264 43.6267 94.3497 46.9155L92.7313 56.1451C92.2331 58.9867 89.9115 61.1537 87.0423 61.4552L76.8952 62.5217L80.5061 41.9289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.1572,
    y: 44.0684,
    width: 8.61539,
    height: 20.1026,
    rx: 1.4359,
    transform: "rotate(-6 60.1572 44.0684)",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.075 80.819C212.231 82.4344 224.206 73.0788 225.821 59.9228C227.436 46.7668 218.081 34.7922 204.925 33.1768C191.769 31.5615 179.794 40.917 178.179 54.0731C176.563 67.2291 185.919 79.2037 199.075 80.819Z",
    fill: "#EC1D4F"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_10814_8122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 45.2805C200.593 43.9691 201.97 43.1956 203.399 43.371C205.283 43.6024 206.582 45.3756 206.233 47.2419L205.292 52.2835L203.989 67.3137L196.507 66.395C195.916 66.3225 195.497 65.7852 195.569 65.1949L197.195 51.9517C197.248 51.5192 197.367 51.0973 197.546 50.7003L200 45.2805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.024 52.2515L211.287 53.0206C213.773 53.3258 215.275 55.9251 214.299 58.2312L211.559 64.7029C210.716 66.6954 208.653 67.8874 206.506 67.6237L198.911 66.6911L205.024 52.2515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.793,
    y: 50.3809,
    width: 6.46154,
    height: 15.0769,
    rx: 1.07692,
    transform: "rotate(7 189.793 50.3809)",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.535 58.9609C176.978 59.7703 190.152 47.9075 190.962 32.4647C191.771 17.0219 179.908 3.84699 164.466 3.03767C149.023 2.22835 135.848 14.0911 135.038 29.5339C134.229 44.9767 146.092 58.1516 161.535 58.9609Z",
    fill: "#EC1D4F"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_10814_8122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.717 17.5279C160.301 15.9533 161.841 14.941 163.518 15.0289C165.73 15.1448 167.386 17.1029 167.132 19.3032L166.447 25.2475L166.153 42.846L157.371 42.3857C156.678 42.3494 156.145 41.7582 156.182 41.0653L156.996 25.5202C157.023 25.0126 157.126 24.5119 157.303 24.0352L159.717 17.5279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.133 25.2318L173.485 25.6171C176.403 25.77 178.363 28.6729 177.414 31.4362L174.753 39.1911C173.933 41.5787 171.63 43.1337 169.109 43.0016L160.194 42.5344L166.133 25.2318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.254,
    y: 24.2949,
    width: 7.53846,
    height: 17.5897,
    rx: 1.25641,
    transform: "rotate(3 148.254 24.2949)",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.395 41.9488C129.414 41.1783 137.722 31.6212 136.951 20.6024C136.181 9.58364 126.623 1.27577 115.605 2.04628C104.586 2.81679 96.2779 12.3739 97.0484 23.3927C97.819 34.4115 107.376 42.7193 118.395 41.9488Z",
    fill: "#EC1D4F"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_10814_8122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.5 12.7312C113.777 11.564 114.78 10.7123 115.977 10.6286C117.555 10.5183 118.899 11.7624 118.911 13.3444L118.943 17.6183L120.267 30.1205L114 30.5587C113.506 30.5933 113.077 30.2205 113.042 29.726L112.267 18.6343C112.241 18.272 112.271 17.9081 112.355 17.5548L113.5 12.7312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.719 17.6344L123.965 17.2675C126.047 17.1219 127.689 19.0094 127.257 21.051L126.045 26.7807C125.672 28.5447 124.174 29.8477 122.375 29.9734L116.014 30.4183L118.719 17.6344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.962,
    y: 18.5254,
    width: 5.38462,
    height: 12.5641,
    rx: 0.897436,
    transform: "rotate(-4 105.962 18.5254)",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 90C57 88.8954 57.8954 88 59 88H79.2654C80.2607 88 81.1046 88.7319 81.2453 89.7172L84.7547 114.283C84.8954 115.268 85.7393 116 86.7346 116H187.265C188.261 116 189.105 115.268 189.245 114.283L192.755 89.7172C192.895 88.7319 193.739 88 194.735 88H215C216.105 88 217 88.8954 217 90V116V142C217 143.105 216.105 144 215 144H185H89H59C57.8954 144 57 143.105 57 142V116V90Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 99.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 13.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 12.5,
    r: 1.5,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 41L7 36",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21 78L2.5 81.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M243.5 40.5L263 36",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M239 77L253 80.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.5,
    cy: 95.5,
    r: 1.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 29 148)",
    fill: "#24284E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10814_8122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.4615,
    height: 31.5897,
    fill: "white",
    transform: "translate(150.427 75.3125) rotate(5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10814_8122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.1538,
    height: 27.641,
    fill: "white",
    transform: "translate(86.8457 84.1172) rotate(-4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10814_8122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.8462,
    height: 23.6923,
    fill: "white",
    transform: "translate(115.377 48.002) rotate(-3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_10814_8122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.4615,
    height: 31.5897,
    fill: "white",
    transform: "translate(58.957 32.6406) rotate(-6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_10814_8122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.8462,
    height: 23.6923,
    fill: "white",
    transform: "translate(190.843 41.8301) rotate(7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_10814_8122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.1538,
    height: 27.641,
    fill: "white",
    transform: "translate(148.78 14.2559) rotate(3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_10814_8122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.5385,
    height: 19.7436,
    fill: "white",
    transform: "translate(105.461 11.3652) rotate(-4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveEncouragingSomeone);
export default __webpack_public_path__ + "static/media/collective-encouraging-someone.ac96885fb2d9e0254a8f8bf034579c20.svg";
export { ForwardRef as ReactComponent };